import React from "react";
import { CCol, CFormGroup, CInput, CLabel, CRow } from "@coreui/react";
import { useDebitNoteFormContext } from "../context/DebitNoteFormContext";
import { FieldErrors } from "../../form/FieldErrors";
import { getFieldErrors } from "../../../models/errors";
import { CLIENT_TYPE_GOVERNMENT } from "../../../models/client";

const SectionDivider: React.FC<{ icon: string; label: string }> = ({ icon, label }) => (
  <div style={{ display: "flex", alignItems: "center", marginBottom: "16px", marginTop: "16px" }}>
    <div style={{ width: "4px", height: "18px", background: "#f9b115", borderRadius: "2px", marginRight: "10px", flexShrink: 0 }} />
    <i className={`fa ${icon} mr-2`} style={{ fontSize: "0.85rem", color: "#f9b115" }}></i>
    <h6 style={{ margin: 0, fontWeight: 600, color: "var(--theme-muted)", fontSize: "0.78rem", textTransform: "uppercase", letterSpacing: "0.8px" }}>
      {label}
    </h6>
    <div style={{ flex: 1, height: "1px", background: "var(--theme-divider)", marginLeft: "10px" }} />
  </div>
);

const FormLabel: React.FC<{ required?: boolean; children: React.ReactNode }> = ({ required, children }) => (
  <CLabel className="mb-0" style={{ fontWeight: 600, fontSize: "0.875rem", color: "var(--theme-text-soft)" }}>
    {required && <span className="text-danger mr-1">*</span>}
    {children}
  </CLabel>
);

export const DebitNoteFormDNCPSection: React.FC = () => {
  const {
    debitNoteRef,
    client,
    errors,
    readonly,
    onDncpContractCodeChange,
    onDncpContractModalityChange,
    onDncpContractDateChange,
  } = useDebitNoteFormContext();

  if (client === null || client.type !== CLIENT_TYPE_GOVERNMENT) {
    return null;
  }

  return (
    <>
      <SectionDivider icon="fa-building-o" label="Datos de Contratación DNCP" />
      <div
        style={{
          background: "var(--theme-warning-surface)",
          border: "1px solid var(--theme-warning-border)",
          borderRadius: "8px",
          padding: "16px 20px",
          marginBottom: "16px",
        }}
      >
        <CFormGroup className="mb-0">
          <CRow className="align-items-center">
            <CCol md={2}>
              <FormLabel required>Código de Contratación:</FormLabel>
            </CCol>
            <CCol md={2}>
              <CInput
                type="text"
                placeholder="Código de Contratación"
                onChange={onDncpContractCodeChange}
                defaultValue={
                  debitNoteRef.current !== null &&
                  debitNoteRef.current.dncpContractCode
                    ? debitNoteRef.current.dncpContractCode
                    : ""
                }
                disabled={readonly}
              ></CInput>
              <FieldErrors
                errors={getFieldErrors("dncpContractCode", errors) as string[]}
              ></FieldErrors>
            </CCol>
            <CCol md={2}>
              <FormLabel required>Modalidad:</FormLabel>
            </CCol>
            <CCol md={2}>
              <CInput
                type="text"
                placeholder="Modalidad de Contratación"
                onChange={onDncpContractModalityChange}
                defaultValue={
                  debitNoteRef.current !== null &&
                  debitNoteRef.current.dncpContractModality
                    ? debitNoteRef.current.dncpContractModality
                    : ""
                }
                disabled={readonly}
              ></CInput>
              <FieldErrors
                errors={
                  getFieldErrors("dncpContractModality", errors) as string[]
                }
              ></FieldErrors>
            </CCol>
            <CCol md={2}>
              <FormLabel required>Fecha:</FormLabel>
            </CCol>
            <CCol md={2}>
              <CInput
                type="date"
                placeholder="Fecha"
                onChange={onDncpContractDateChange}
                defaultValue={
                  debitNoteRef.current !== null &&
                  debitNoteRef.current.dncpContractDate
                    ? debitNoteRef.current.dncpContractDate
                    : ""
                }
                disabled={readonly}
              ></CInput>
              <FieldErrors
                errors={getFieldErrors("dncpContractDate", errors) as string[]}
              ></FieldErrors>
            </CCol>
          </CRow>
        </CFormGroup>
      </div>
    </>
  );
};
